import { OfferingApiCreateCategoryPayload } from 'modules/shared-menu/types';

import { CategoryFormData } from './types';

type BuildOfferingApiCategoryPayloadArgs = {
  category: Omit<CategoryFormData, 'childCategories'>;
  selectionId: string;
  primaryLanguage: Language;
  imageUrl: string | undefined;
  userId: string;
};

export const buildOfferingApiCategoryPayload = ({
  category,
  selectionId,
  primaryLanguage,
  imageUrl,
  userId,
}: BuildOfferingApiCategoryPayloadArgs): OfferingApiCreateCategoryPayload | undefined => {
  if (!category.name.trim()) {
    return undefined;
  }

  const currentDateIsoString = new Date().toISOString();

  return {
    name: [{ value: category.name, lang: primaryLanguage, verified: true }],
    description: !!category.description
      ? [{ value: category.description, lang: primaryLanguage, verified: true }]
      : undefined,
    image: imageUrl ?? undefined,
    image_blurhash: undefined,
    is_wolt_special: false,
    offer_bindings: undefined,
    selection_id: selectionId,
    author: {
      kind: 'user',
      id: userId,
    },
    version: {
      number: 1,
      updated_at: currentDateIsoString,
      created_at: currentDateIsoString,
      author: userId,
    },
  };
};
